export default {_name:'Icon.Status',module:'Field',view:'Element/Icon/Status',webOptions:{xs:'auto'},mobileOptions:{ms:'auto'}}